import React, { Component } from 'react'
import s from './style.scss'
import classnames from 'classnames'

import { Query } from "react-apollo";
import gql from "graphql-tag";

import Dropdown from '../../components/Dropdown'

const QUERY = gql`
query findUser($input: String) {
  users(filter: { OR: [
    { email_contains: $input },
    { phone_number_contains: $input },
    { first_name_contains: $input },
    { last_name_contains: $input }
  ] }, first: 20) {
    id
    _id
    first_name
    last_name
    email
    phone_number
    role
  }
}
`

class UserSelection extends Component {

	state = {
		hidden: true,
		input: ''
	}

	render() {

		console.log('USER SELECTION')

		const { hidden, input } = this.state 

		return <div className={classnames(s.container)}>

			<Query
      query={QUERY}
      variables={{
        input: input
			}}>
			
			{({ loading, error, data }) => {
				
				if (error) {
					console.error(error)
					return <p>Error :(</p>
				};

				return <Dropdown 
					options={data.users && input.length > 0 ? data.users.map(({ ...user, id, _id, email, first_name, last_name, phone_number}) => ({
						value: user,
						label: <span>
							<b>{first_name ? first_name + ' ' + last_name : email || phone_number}</b> <br/>
							<small>{email} • {phone_number} </small><br />
							<small>{id} • {_id}</small>
						</span>
					})) : []}
					onSelect={(value) => {
						this.setState({ hidden: true, input: '' })
						this.props.onSelect(value)
					}}
					hidden={hidden}>

					<input
						type="text"
						placeholder="Name, email or phone"
						onFocus={() => this.setState({ hidden: false })}
						// onBlur={() => setTimeout(() => this.setState({ hidden: true }), 250)}
						value={input}
						onChange={e => this.setState({ input: e.target.value })}
						className={s.input}
						/>
					
				</Dropdown>
			}}

			</Query>
		
			
		</div>
	}
}

export default UserSelection


// WEBPACK FOOTER //
// ./src/components/UserSelection/index.js